/** Created by azhou on 2019/3/25.*/
<template>
  <div>
    <ul class="list-item">
      <li class="w-50 list-item-col text-muted" >{{item.title}}</li>
      <li class="w-50 list-item-col">{{item.mob}}</li>
      <li class="w-50 list-item-col">{{item.id_card||'无'}}</li>
      <li class="w-50 list-item-col">{{item.sex | formatVar('sex')}}</li>
      <li class="w-50 list-item-col text-muted breakword">{{item.level}}</li>
      <li class="w-50 list-item-col text-muted" >{{item.work_seniority}}</li>
      <li class="w-50 list-item-col" :class="[item.verify==1?'text-success':'text-danger']">
        {{item.verify | formatVar('verifyType')}}
      </li>
      <li class="w-50 list-item-col" :class="[item.display==1?'text-success':'text-danger']" v-if="userLoginMessage.type == 99">
        {{item.display == 1 ?'已显示':'未显示'}}
      </li> 
      <li class="w-50 list-item-col-end">
        <span v-if="userLoginMessage.type == 99" class="text-link" @click="$emit('goStoreDetail',item.id)">编辑</span>
        <span v-else class="text-link" @click="$router.push({name:'GuideMsg',query:{id:item.id,store:$route.query.store,flag:item.flag}})">查看</span>
      </li>
    </ul>
  </div>
</template>

<script>
  import { mapState,mapGetters } from 'vuex'

  export default {
    name: 'StoreLists',
    props:{
      item:{}
    },
    computed: {
      ...mapState(['userLoginMessage']),
      ...mapGetters(['storeInfo']),
      storeType() { return Number(this.$route.query.storeType) },
    }
  }
</script>
